(function () {
'use strict';

function generalInit(){
	(function($){
	
		function myScrollTo( $target, $trigger ){
			if( $target.length ) {
				var offTop = $target.position().top;
				
				if( $trigger.attr('data-ignore-header') === undefined ){ 
					offTop -= $('#site-header').outerHeight();
					offTop -= 40;
				}
				
				var animationTime = Math.abs( offTop - $(window).scrollTop() ) * 1.2;
				
				$('html, body').stop().animate( {scrollTop: offTop}, animationTime );
			}
		}
		
		$('a[href="#"]').click(function(e){
			e.preventDefault();
		});
		
		$('a[data-scroll-down]').click(function(e){
			
			var $target = $( $(this).attr('href') );
			if( !$target.length ) $target = $(this).closest('section').next('section');
			
			if( $target.length ) e.preventDefault();
			
			myScrollTo($target, $(this) );
			
		});
	
		//add simple support for background images:
		$(document).on('lazybeforeunveil', function(e){
	    var bg = $(e.target).attr('data-bg');
	    if(bg){
	      e.target.style.backgroundImage = 'url(\'' + bg + '\')';
	    }
		});
		
	})(jQuery);
}

function slidersInit(){
	
	(function($){
	
	
    //slider on front_page
    $(".owl-1").owlCarousel({
        responsive: {
            0: {
                items: 3,
                stagePadding: 0
            },
            980: {
                items: 2,
                stagePadding: 20
            },
            // 1100: {
            //     items: 2,
            //     stagePadding: 80
            // },
            1360: {
                items: 2,
                stagePadding: 100
            },
            1600: {
                items: 3,
                stagePadding: 20
            }
        },
     
        loop: true,
        margin: 10,
        autoplay: 2000,
        stopOnHover: true,
        smartSpeed: 1000,
        slideTransition: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
        dots: true,
        // autoHeight: true
    });






    //slider partnerzy

    $(".owl-2").owlCarousel({
        responsive: {
            0: {
                items: 3,
                margin: 40,
                nav: false
               
            },
            640: {
                items: 4,
                margin: 40,
                nav: false
            },
            830: {
                items: 4,
                margin: 60,
                nav: true,
            },
            1200: {
                items: 5,
                margin: 50
            }
        },
        loop: true,

        autoplay: 2000,
        stopOnHover: true,
        smartSpeed: 850,
        slideTransition: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
        nav: true,
        // autoplayTimeout:1000,
        dots: false,
        autoHeight: true,
        	navText:[`<svg xmlns="http://www.w3.org/2000/svg" width="28" height="53" viewBox="0 0 28 53">
            <text id="_" data-name="&gt;" transform="translate(28 10) rotate(180)" fill="#b2b2b2" font-size="40" font-family="SegoeUI, Segoe UI"><tspan x="0" y="0">&gt;</tspan></text>
          </svg>`, `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="53" viewBox="0 0 28 53">
          <text id="_" data-name="&gt;" transform="translate(0 43)" fill="#b2b2b2" font-size="40" font-family="SegoeUI, Segoe UI"><tspan x="0" y="-8">&gt;</tspan></text>
        </svg>`],
    });
		
	})(jQuery);
	
}

function menuInit(){
	
	(function($){

	var menu_breakpoint = 'large';
	
	function fixedNav(){
		
		if( ! $('body').hasClass('fixed-nav') ) return;
		
		var scrolltop = $(window).scrollTop();
		var hTop = 0;
		
	
		if(scrolltop > hTop && !$('body').hasClass('scrolled') ){
			$('body').addClass('scrolled');
		}
		if(scrolltop <= hTop && $('body').hasClass('scrolled') ){
			$('body').removeClass('scrolled');
		}
			
	}
	
	function menuEvents(){
		
		$('#site-header .menu li.menu-item-has-children').append('<div class="arrow">');
	
		$('#site-header .menu li.menu-item-has-children .arrow').click(function(){
			$(this).siblings('.sub-menu').stop().slideToggle(200);
		});
		
		$('#site-header .menu li.menu-item-has-children > a[href="#"]').click(function(){
			if( ! Foundation.MediaQuery.atLeast(menu_breakpoint) ){
				$(this).siblings('.sub-menu').stop().slideToggle(200);
			}
		});
		
		$('#site-header .menu .menu a:not([href="#"])').click(function(){
			if( ! Foundation.MediaQuery.atLeast(menu_breakpoint) ){
				$('#site-header .menu-wrap').removeClass('active');
			}
		});
		
		$('#hamburger').click(function(){
			if( ! Foundation.MediaQuery.atLeast(menu_breakpoint) ){
				$('#site-header .menu-wrap').toggleClass('active');
			}
		});
		
		$('#site-header .menu li.menu-item-has-children').hover(function(){
			if( Foundation.MediaQuery.atLeast(menu_breakpoint) ){
				$(this).children('.sub-menu').stop().fadeIn(200);
			}
		}, function(){
			if( Foundation.MediaQuery.atLeast(menu_breakpoint) ){
				$(this).children('.sub-menu').stop().fadeOut(200);
			}
		});
		
		$(window).on('changed.zf.mediaquery', function() {
		  if(Foundation.MediaQuery.atLeast('large')){
				$('#site-header .menu .sub-menu').hide();
			}
		});

		       $('#hamburger-main').click(function () {
        if (!Foundation.MediaQuery.atLeast(980)) {
            $('.menu-wrap').toggleClass('active');
        }
    });

		
	}
	
	fixedNav();
	menuEvents();
	
	$(window).scroll(function(){
		requestAnimationFrame(function(){
			fixedNav();
		});
	});
	 
	})(jQuery);
	
}

function galleryInit(){
	(function($){
		
		$('.post-content .gallery').each(function(i){
			$(this).find('.gallery-item').each(function(){
				
				$(this).find('.gallery-icon a').attr('data-fancybox', 'post-gallery-' + i);
				
				if( $(this).find('.wp-caption-text') ){
					var captionText = $(this).find('.wp-caption-text').html();
					$(this).find('.gallery-icon a').attr('data-caption', captionText);
				}
			});
		});
		
	})(jQuery);
}

function loadMoreInit(){
	(function($){
		
		function ajax_show_more($wrapper, template, btn){
		
	    if( btn.hasClass('is-loading') ) return;
	
	
	    var data = {
	    	'action': 'loadmore',
        'query': wp_params.posts, // that's how we get wp_params from wp_localize_script() function
        'page' : wp_params.current_page,
        'template' : template
	    }; 
	
	    $.ajax({
	        url : wp_params.ajax_url, // AJAX handler
	        data : data,
	        type : 'POST',
	        beforeSend : function ( ) {
		        btn.addClass('is-loading');
	        },
	        success : function( data ){
	          if( data ) { 

              var disp = $wrapper.children().first().css('display');

              $wrapper.append(data);
              $wrapper.find('.ajax-loaded').css({display: disp}).hide();
              $wrapper.find('.ajax-loaded').fadeIn(400).removeClass('ajax-loaded');

              btn.removeClass('is-loading');

              wp_params.current_page++;

              if ( wp_params.current_page == wp_params.max_page ) {
                  btn.addClass('fading').fadeOut(400);
                  btn.removeClass('is-loading').addClass('no-posts');
              }
              // you can also fire the "post-load" event here if you use a plugin that requires it
              $( document.body ).trigger( 'post-load' );
	
	          } else {
              btn.addClass('fading').fadeOut(400);
              btn.removeClass('is-loading').addClass('no-posts');
	          }
	        }
	    });
		}
		
		
		// Preload icon
		$('[data-loadmore]').addClass('is-loading');
		setTimeout(function(){
			$('[data-loadmore]').removeClass('is-loading');
		}, 20);
		
    $('[data-loadmore]').on('click', function(){
      var $wrapper = $( $(this).attr('data-wrap') );
      var btn = $(this);
      var template = $(this).attr('data-template');
      
      ajax_show_more($wrapper, template, btn);
    });
		
	})(jQuery);
}

(function ($) {


	// $(document).foundation();

	$(document).ready(function () {

		generalInit();
		slidersInit();
		menuInit();
		galleryInit();
		loadMoreInit();

		//menu-sticy
		$(window).scroll(function () {
			if ($(window).width() >= 980) {
				if ($(this).scrollTop() > 1) {
					$('#navbar').addClass("sticky");
					$('.header-main').removeClass("stretch-left grid-container-left");
					$('.logo-box-box').addClass("medium-6 large-6");
					$('.logo-box-box').removeClass("medium-5 large-4");

				} else {
					$('#navbar').removeClass("sticky");
					$('.header-main').addClass("stretch-left grid-container-left");
					$('.logo-box-box').removeClass("medium-6 large-6");
					$('.logo-box-box').addClass("medium-5 large-4");
				}

			}
		});


		//matchHeight



		// // When the user scrolls the page, execute myFunction
		// window.onscroll = function() {myFunction()};

		// // Get the navbar
		// var navbar = document.getElementById("navbar");

		// // Get the offset position of the navbar
		// var sticky = navbar.offsetTop;

		// // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
		// function myFunction() {
		//   if (window.pageYOffset >= sticky) {
		//     navbar.classList.add("sticky")
		//   } else {
		//     navbar.classList.remove("sticky");
		//   }
		// }





		// $(".single-ofert .big-title").matchHeight();

		//dynamic-class-single_ofert

		//toggle with arrow

		// $(' .big-li').click(function () {

		// 	let element_id = $(this).attr('data-show-panel');
		// 	let name = ".toggle-li-" + element_id;
		// 	$(name).slideToggle();
		// 	console.log(name);

		// });

		//show-big-li-text

	//	$('.dynamic-left .menu-item-has-children').click(function (e) {
			//e.preventDefault()
		//	let element_id = $(this).attr('data-show-panel');
		//	let target = ".panel-" + element_id;
		//	$(target).show();
		//	$('.dynamic-left .sub-menu').slideToggle();
		//	$(this).addClass("add-opacity");
	//		$(this).siblings().removeClass("add-opacity");
		//	$(target).siblings().hide();
	//	})

		//show small-li text

		// $('body').on('click', '.small-li', function (e) {
		// 	e.preventDefault()
		// 	let element_id = $(this).attr('data-show-small');
		// 	let target = ".small-li-" + element_id;
		// 	$(target).show();
		// 	$(this).addClass("add-opacity");
		// 	$(this).siblings().removeClass("add-opacity");
		// 	$(target).siblings().hide();
		// });

		///////////////map

		$('.map-title h3').click(function () {
			// $('.map-image').slideToggle();

			$('html,body').animate({
				scrollTop: $(this).offset().top
			}, 500);
		});

		//////////////////job-toggle
		$(".offer").click(function () {


			let id_faq = $(this).attr('data-show-offer');
			let target = '.offer-text-' + id_faq;
			if ($(".offer-text:visible").not($(target)).length) {
				$(".offer-text").hide();
				// $(".offer-text").slideUp();

				$(this).siblings().removeClass('offer-added-class rotate');
			}

			$(this).toggleClass('offer-added-class rotate');
			$(target).slideToggle();




		});

		// $(".offer:first-child").click(function () {
		// 	$('html,body').delay(500).animate({
		// 		scrollTop: $(this).offset().top - 180
		// 	}, 'slow');
		// });
		// $(".offer:not(:first-child)").click(function () {
		// 	$('html,body').delay(500).animate({
		// 		scrollTop: $(this).offset().top - 100
		// 	}, 'slow');
		// });
		$(".offer").click(function () {
			$('html,body').animate({
				scrollTop: $(this).offset().top - 100
			}, 'slow');
		});






	});


	/**
		*Scroll to anchor
		*/

	// Select all links with hashes
	$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.click(function (event) {
			// On-page links
			if (
				location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
				&&
				location.hostname == this.hostname
			) {
				// Figure out element to scroll to
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$('html, body').animate({
						scrollTop: target.offset().top
					}, 1050, function () {
						// Callback after animation
						// Must change focus!
						var $target = $(target);
						$target.focus();
						if ($target.is(":focus")) { // Checking if the target was focused
							return false;
						} else {
							$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
							$target.focus(); // Set focus again
						}
					});
				}
			}
		});






})(jQuery);

}());
